module.exports = __webpack_public_path__ + "img/check.a26be7d4.svg";